module.exports = __webpack_public_path__ + "img/schoen.fa55f8f9.jpg";